import * as Yup from "yup";
import { useTranslation } from "react-i18next";

const ForgetPasswordSchema = () => {
  const { t } = useTranslation();
  return Yup.object().shape({
    phoneNumber: Yup.string().required(t("required_phone_number")),
  });
};

export default ForgetPasswordSchema;
